<hr>
<div class="grid mb-4">
  <div class="col-12">
    <span class="section-title mt-3" translate>payment_detail_comments_label</span>
  </div>
  <div class="col-12">
    @if (editMode) {
      <textarea id="commentTextArea" pTextarea [(ngModel)]="comment"
        (ngModelChange)="onChange()" rows="4"></textarea>
    } @else {
      <span id="comment" class="field-value">{{ comment }}</span>
    }
  </div>
</div>
